export default {"src":"/_next/static/media/favicon-codeai.fd1175d1.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};